import { helper } from '@ember/component/helper';

export function enumLabel([theEnum, value]) {
  return theEnum.getLabel(value);
}

export default helper(enumLabel);
